const panelTransitionDurationMs = 100;
const screenTransitionDurationMs = 300;
const wrapperCls = "c2lw12hw8k2";
const animationCls = "c2la1dfh1cl";
const iframeCls = "c2lij3osk0";
const screenTitleCls = "c2ls1xea2l4";
const screenBodyCls = "c2lsovo491";
const screenCls = "c2lshcchw4";
const bulletsCls = "c2lbuchiha";
const buttonsWrapperCls = "c2lb7gd0yj";
const buttonCls = "c2lb2c0ujc";
const beginButtonCls = "c2lb12oe75z";

export { animationCls, beginButtonCls, bulletsCls, buttonCls, buttonsWrapperCls, iframeCls, panelTransitionDurationMs, screenBodyCls, screenCls, screenTitleCls, screenTransitionDurationMs, wrapperCls };
import "./_onboarding.style.linaria.module.css";
//# sourceMappingURL=_onboarding.style.js.map
